// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u4ZRj","tabsBox":"styles_tabsBox__J1ZTK","createButton":"styles_createButton__ASNhm"};